import { createFileRoute } from '@tanstack/react-router';
import { requireFeature } from '@portal/platform/guards';
import { CalculatePage } from '@/features/service-agreements/calculate-page';
import { AGREEMENT_TYPE_VALUES, type AgreementType } from '@/features/service-agreements/types';

interface CalculateSearch {
  vehicleId?: string;
  agreementType?: AgreementType;
}

/** A new agreement for one car. Pricing and creating require `service-agreement:update`. */
export const Route = createFileRoute('/_app/service-agreement/orders/calculate')({
  staticData: { featureKey: 'service-agreements' },
  validateSearch: (search: Record<string, unknown>): CalculateSearch => ({
    ...(typeof search['vehicleId'] === 'string' && search['vehicleId']
      ? { vehicleId: search['vehicleId'] }
      : {}),
    ...(AGREEMENT_TYPE_VALUES.includes(search['agreementType'] as AgreementType)
      ? { agreementType: search['agreementType'] as AgreementType }
      : {}),
  }),
  beforeLoad: ({ context, location }) =>
    requireFeature(context, location, {
      feature: 'service-agreements',
      permissions: ['service-agreement:update'],
    }),
  component: Calculate,
});

function Calculate() {
  const { vehicleId, agreementType } = Route.useSearch();
  return <CalculatePage vehicleId={vehicleId} agreementType={agreementType} />;
}
